import type { FC } from 'react';

import type { StandardLayoutProps } from './StandardLayout.interface';
import { Navbar } from '@/shared/components/Navigation/Navbar';
import { Footer } from '@/shared/components/Navigation/Footer';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { OptimizedImage } from '@/shared/components/OptimizedImage';

export const StandardLayout: FC<StandardLayoutProps> = ({ children }) => {
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  return (
    <div className='min-h-screen'>
      <Navbar />
      <div className='mt-8 flex justify-center py-1'>
        <Link to='/'>
          <OptimizedImage
            src='/images/branded-logo.webp'
            alt='Branded logo'
            width={isHomePage ? 521 : 313}
            height={isHomePage ? 200 : 120}
            aspectRatio={isHomePage ? '521/200' : '313/120'}
            priority
            blur={false}
            objectFit='contain'
            className={isHomePage ? 'h-32 md:h-50' : 'h-20 md:h-30'}
            wrapperClassName={isHomePage ? 'h-32 md:h-50' : 'h-20 md:h-30'}
          />
        </Link>
      </div>
      {/* <main>{children || <AnimatedOutlet />}</main> */}
      <main className='m-auto max-w-7xl'>{children ?? <Outlet />}</main>
      <Footer />
    </div>
  );
};
